import separator from 'components/content/separator';
import { Constructor } from 'interfaces/constructor';
import { WCCContentBlock } from '../blocks/block/block';
import { IWCCContentBlockSplitOptions } from '../blocks/block/block.interfaces';
import { WCCContentBlockFactory } from '../parser.interfaces';

export function MakeWCCContentBlockWithSplit<TBase extends Constructor<any[], WCCContentBlock>>(Base: TBase) {
    abstract class ExtendedWCCContentBlock extends Base {
        override splitBy(options: IWCCContentBlockSplitOptions, factory: WCCContentBlockFactory) {
            return separator.separate(this.content, options, (content, isMatch) => {
                return isMatch ? factory(content) : this.clone({ content: content });
            });
        }
    }

    return ExtendedWCCContentBlock;
}